import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const STATUS_META = {
  draft:        { label: 'Bozza',           cls: 'badge-gray',  desc: 'Il questionario è ancora in bozza.' },
  submitted:    { label: 'In valutazione',  cls: 'badge-amber', desc: 'Il questionario è stato inviato. In attesa di revisione da parte del certificatore.' },
  under_review: { label: 'In revisione',    cls: 'badge-amber', desc: 'Il certificatore sta esaminando il tuo progetto.' },
  certified:    { label: 'Certificato ✓',   cls: 'badge-green', desc: 'Il tuo software ha ottenuto la certificazione ESG.' },
  rejected:     { label: 'Non approvato',   cls: 'badge-red',   desc: 'Il progetto non ha superato la revisione.' },
};

const LEVEL_LABELS = { 1: '🥉 Livello 1 — Base', 2: '🥈 Livello 2 — Avanzato', 3: '🥇 Livello 3 — Eccellenza' };

export default function ProjectDetailPage() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/projects/${id}`).then(r => setProject(r.data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#9B9A92' }}>Caricamento...</div>;
  if (!project) return <div style={{ padding: 40 }}>Progetto non trovato</div>;

  const sm = STATUS_META[project.status];

  return (
    <>
      <div className="topbar">
        <span className="topbar-title">{project.name}</span>
        {project.status === 'draft' && (
          <Link to={`/dashboard/projects/${id}/questionnaire`} className="btn btn-primary btn-sm">
            Continua il questionario →
          </Link>
        )}
      </div>
      <div className="page-content">
        <div style={{ maxWidth: 720 }}>

          {/* Status banner */}
          <div className="card" style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 14, borderLeft: `4px solid ${project.status === 'certified' ? '#1D9E75' : project.status === 'rejected' ? '#E24B4A' : '#EF9F27'}` }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <span className={`badge ${sm.cls}`}>{sm.label}</span>
                {project.certificationLevel && <span className="badge badge-green">{LEVEL_LABELS[project.certificationLevel]}</span>}
              </div>
              <p style={{ fontSize: 14, color: '#5C5B55' }}>{sm.desc}</p>
            </div>
          </div>

          {/* Certifier notes */}
          {project.certifierNotes && (
            <div className="card" style={{ marginBottom: 16, background: '#FAEEDA', borderColor: '#EF9F27' }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#854F0B', marginBottom: 4 }}>NOTE DEL CERTIFICATORE</div>
              <p style={{ fontSize: 14 }}>{project.certifierNotes}</p>
            </div>
          )}

          {/* Score */}
          {project.scoreTotal > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 16 }}>
              <div className="stat-card" style={{ textAlign: 'center' }}>
                <div className="stat-label">Punteggio ESG</div>
                <div className="stat-value" style={{ color: '#1D9E75' }}>
                  {project.scorePercentage != null
                    ? `${Math.round(project.scorePercentage)}%`
                    : `${Math.round((project.scoreTotal / 125) * 100)}%`}
                </div>
                {/* <div className="stat-sub">{Math.round(project.scoreTotal)}/125 punti</div> */}
              </div>
              <div className="stat-card" style={{ textAlign: 'center' }}>
                <div className="stat-label">🌱 Environmental</div>
                <div className="stat-value">{Math.round((project.scoreEnvironmental / 30) * 100)}%</div>
                {/* <div className="stat-sub">{Math.round(project.scoreEnvironmental)}/30</div> */}
              </div>
              <div className="stat-card" style={{ textAlign: 'center' }}>
                <div className="stat-label">🤝 Social</div>
                <div className="stat-value">{Math.round((project.scoreSocial / 45) * 100)}%</div>
                {/* <div className="stat-sub">{Math.round(project.scoreSocial)}/45</div> */}
              </div>
              <div className="stat-card" style={{ textAlign: 'center' }}>
                <div className="stat-label">⚖️ Governance</div>
                <div className="stat-value">{Math.round((project.scoreGovernance / 50) * 100)}%</div>
                {/* <div className="stat-sub">{Math.round(project.scoreGovernance)}/50</div> */}
              </div>
            </div>
          )}

          {/* Project info */}
          <div className="card">
            <h3 style={{ fontSize: 15, marginBottom: 14 }}>Dettagli progetto</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px', fontSize: 14 }}>
              {[
                ['Categoria', project.category],
                ['Deploy', project.deploymentType],
                ['Team', project.teamSize ? `${project.teamSize} persone` : '—'],
                ['Linguaggi', project.programmingLanguages?.join(', ') || '—'],
                ['Azienda', project.company?.name],
                ['Creato il', new Date(project.createdAt).toLocaleDateString('it-IT')],
              ].map(([k, v]) => v ? (
                <div key={k}>
                  <span style={{ color: '#9B9A92', fontSize: 12 }}>{k}</span>
                  <div style={{ fontWeight: 500 }}>{v}</div>
                </div>
              ) : null)}
            </div>
            {project.description && (
              <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #E0DED6' }}>
                <div style={{ color: '#9B9A92', fontSize: 12, marginBottom: 4 }}>Descrizione</div>
                <p style={{ fontSize: 14 }}>{project.description}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
